import { useAppStore } from "@/stores/app";
import type { Router } from "vue-router";

export interface FlowConfig {
  //TODO isso aqui ainda vai mudar porque provavelmente vai ser uma árvore já que tem mais de uma opção
  orderedPageRoutes: string[]; //Utilizado para definir a ordem default, as páginas que tiverem mais de uma opção vão somente
  features: {
    hasSomeFeature: boolean; //Utilizado para dar IF em alguma lógica ou renderização
  };
  apiPrefix?: string; //Utilizado ao fazer requisições para o backend
}

export const flowConfigMap: Record<string, FlowConfig> = {
  bikeWithTag: {
    orderedPageRoutes: [
      "home",
      "planSelection",
      "termsOfService",
      "clientCpf",
      "address",
      "payment",
      "end",
    ],
    features: {
      hasSomeFeature: false,
    },
  },
  bikeWithoutTag: {
    orderedPageRoutes: [
      "home",
      "bikePossession",
      // serial number não consegue ser setado nesse momento, pois ele precisa de uma relação com o clientBike
      "bikeSerialNumber",
      "clientInfo",
      "clientVerification",
      // o setBike define o clientBike que está sendo definido dentro da página bikeReceipt. Não aparenta ter dependências de outras informações
      "bikeModel",
      // setBike e sendBikeSerialNumber sendo setados nesta página, também é feito um getData que não sei se realmente precisa dele. O setBike retorna o mesmo DTO de info do getData
      "bikeReceipt",
      "planSelection",
      "clientCpf",
      "address",
      "selfie",
      "photo",
      "video",
      "payment",
      "end",
    ],
    features: {
      hasSomeFeature: false,
    },
  },
  caloi: {
    orderedPageRoutes: ["home", "freePlan", "freePlanSelection"],
    features: {
      hasSomeFeature: false,
    },
    apiPrefix: "/caloi",
  },
  specialized: {
    orderedPageRoutes: ["home", "freePlan", "freePlanSelection"],
    features: {
      hasSomeFeature: true,
    },
    apiPrefix: "/specialized",
  },
};

export function initializeFlowFromUrl(router: Router): void {
  const store = useAppStore();
  const brand = store.brand;

  const exceptionRoutes = ["resumeInsurance"];

  const isExceptionRoute = exceptionRoutes.includes(router.currentRoute.value.name as string);

  const existsBrandConfigFlow = brand in flowConfigMap;

  if (brand && existsBrandConfigFlow) {
    const flowConfiguration = flowConfigMap[brand] as FlowConfig;
    store.setFlowConfig(flowConfiguration);

    const firstPageKey = flowConfiguration.orderedPageRoutes[0]?.replace(".vue", "");
    if (firstPageKey && !isExceptionRoute) {
      console.log(store.flowConfig);
      console.log("Redirecionando para " + firstPageKey);
      router.replace({ name: firstPageKey });
    }
  } else {
    console.warn("Fluxo de páginas não configurado para a marca:", brand);
  }
}
